<snelstart-ui-button type="secondary"
                     class="custom-input-150"
                     icon="plus"
                     (click)="this.showDialog()">Specificeer
</snelstart-ui-button>


<snelstart-ui-dialog-definition id="lg" title="Specificatie overige materi&euml;le vaste activa" size="lg"
                                [(visible)]="dialogVisible">

    <snelstart-ui-dialog-header-content>
        Vul onderstaand de waardes is voor de balanspost(en) per einde van het boekjaar.

    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
        <form [formGroup]="materieleVasteActivaOverigFg">
            <div>
                <snelstart-ui-number-form-control formControlName="aanschafWaarde"
                                                  label="Aanschafwaarde"
                                                  class="me-1 custom-input-200"
                                                  [decimals]="0"
                                                  prefix="€"
                                                  align="right"
                                                  (change)=saveForm()
                >
                </snelstart-ui-number-form-control>
            </div>
            <div>
                <snelstart-ui-number-form-control formControlName="restWaarde"
                                                  label="Restwaarde"
                                                  class="me-1 custom-input-200"
                                                  [decimals]="0"
                                                  prefix="€"
                                                  align="right"
                                                  (change)=saveForm()
                >
                </snelstart-ui-number-form-control>
            </div>
        </form>
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button id="cancel" class="me-1" type="secondary" btn-x>Annuleren</snelstart-ui-button>
        <snelstart-ui-button id="save2" type="primary" icon="check">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
